import { Auth } from 'aws-amplify';
import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosRequestHeaders,
} from 'axios';
import appConfig from 'config/appConfig';
import { parseError } from 'helpers/error-parser';

export const request = axios.create({
  baseURL: appConfig.API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use(function (config) {
  return Auth.currentSession()
    .then((session) => {
      // User is logged in. Set auth header on all requests
      config.headers = {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      } as AxiosRequestHeaders;

      return Promise.resolve(config);
    })
    .catch(() => {
      // No logged-in user: don't set auth header
      return Promise.resolve(config);
    });
});

const apiRequest = async ({
  method = 'get',
  url,
  data,
  params,
  headers,
}: AxiosRequestConfig) => {
  try {
    const result = await request({
      method,
      url,
      data,
      params,
      headers,
    } as AxiosRequestConfig);
    return result.data;
  } catch (e) {
    const err = e as AxiosError;
    if (err.response?.status && err.response.status >= 400) {
      throw new Error(parseError(err) as string);
    }
    throw new Error(e as string);
  }
};

export default apiRequest;
